/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * One scratch storage buffer declared on a custom node.
 */
export type ScratchDecl = {
    name: string;
    type: ScratchDecl.type;
    count: (number | string);
};

export namespace ScratchDecl {

    export enum type {
        UINT = 'uint',
        INT = 'int',
        FLOAT = 'float',
        UINT4 = 'uint4',
        FLOAT4 = 'float4',
    }


}

